import React, {Fragment} from 'react';
import createForm from "./Form";
import ComponentField from "../../form/ComponentField";
import Figures from "../../form/Figures";
import {connect} from "src/store";
import TextInput from "../../form/TextInput";
import DateTimeInput from "../../form/DateTimeInput";
import CheckBox from "../../form/CheckBox";
import PodcastEpisodeEditor from "../PodcastEpisodeEditor";
import ModalEditor from "../ModalEditor";
import FragmentEditor from "../FragmentEditor";
import PodcastHostEditor from "../PodcastHostEditor";


class PodcastEpisodeForm extends React.Component<any, object> {


    componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<object>, snapshot?: any) {
        if (prevProps.values[prevProps.componentConfig.idfield] !== this.props.values[this.props.componentConfig.idfield]) {
            this.setState({events: []});
        }
    }

    render() {
        return (
            <Fragment>
                <form onSubmit={this.props.handleSubmit}>
                    <div className="row form-row">
                        <div className="col-sm-2">
                            <ComponentField
                                getFieldProps={this.props.getFieldProps}
                                componentConfig={this.props.componentConfig}
                                name={this.props.componentConfig.idfield}
                                values={this.props.values}
                                setFieldValue={this.props.setFieldValue}
                                label="Kód"
                            />
                        </div>
                        <div className="col-md-5">
                            <TextInput
                                {...this.props.getFieldProps("title")}
                                name="title"
                                value={this.props.values.title}
                                label="Cím"
                                saveChanges={this.props.setFieldValue}
                            />
                        </div>
                        <div className="col-sm-3">
                            <DateTimeInput
                                {...this.props.getFieldProps("publish_date")}
                                name="publish_date"
                                value={this.props.values.publish_date}
                                isClearable={true}
                                label="Közzététel időpontja"
                                showTime={true}
                                saveChanges={this.props.setFieldValue}
                            />
                        </div>
                        <div className="col-md-2">
                            <label className="control-label">&nbsp;</label>
                            <CheckBox
                                name="public"
                                value={this.props.values.public}
                                label="Publikus"
                                saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("public")}
                            />
                        </div>
                    </div>
                    <div className="row form-row">
                        <div className="col-md-12">
                            <ComponentField
                                getFieldProps={this.props.getFieldProps}
                                componentConfig={this.props.componentConfig}
                                name="description"
                                values={this.props.values}
                                setFieldValue={this.props.setFieldValue}
                                label="Leírás"
                            />
                        </div>
                    </div>
                    {this.props.values[this.props.componentConfig.idfield] && <div className="row form-row">
                        <div className="col-sm-12">
                            <Figures name="figures" label="Képek" component={this.props.componentConfig.componentname} componentId={this.props.values[this.props.componentConfig.idfield]} />
                        </div>
                    </div>}
                    <div className="row form-row">
                        <div className="col-md-12">
                            <ComponentField
                                getFieldProps={this.props.getFieldProps}
                                componentConfig={this.props.componentConfig}
                                name="content"
                                values={this.props.values}
                                setFieldValue={this.props.setFieldValue}
                                label="Tartalom"
                            />
                        </div>
                    </div>
                    <div className="row form-row">
                        <div className="col-md-12">
                            <ComponentField
                                getFieldProps={this.props.getFieldProps}
                                componentConfig={this.props.componentConfig}
                                name="url"
                                values={this.props.values}
                                setFieldValue={this.props.setFieldValue}
                                label="Url"
                            />
                        </div>
                    </div>
                    {!!this.props.values[this.props.componentConfig.idfield] &&

                        <div className="row form-row">
                            <div className="col-md-12">
                                <label className="control-label">Közösségi média linkek</label>
                                <PodcastHostEditor
                                    editorContext="PodcastEpisodePodcastHostEditor"
                                    gridid={"PodcastEpisodePodcastHostList"}
                                    presets={{episode: this.props.values}}
                                    isLoading={this.props.isLoading}
                                    editor={ModalEditor}
                                    list={FragmentEditor}
                                    selection={null}
                                    listFilter={[
                                        {
                                            field: "episode",
                                            value: this.props.values[this.props.componentConfig.idfield]
                                        }
                                    ]}
                                />
                            </div>
                        </div>
                    }
                </form>
            </Fragment>
        );
    }
}

export default connect((state) => {
    return {
        partner: state.app.context.partner
    }
})(createForm(PodcastEpisodeForm));
